module.exports = __webpack_public_path__ + "static/media/tap-logo.29755824.png";